import { render, staticRenderFns } from "./InfoAboutAgent.vue?vue&type=template&id=d487045c&scoped=true"
import script from "./InfoAboutAgent.vue?vue&type=script&lang=js"
export * from "./InfoAboutAgent.vue?vue&type=script&lang=js"
import style0 from "./InfoAboutAgent.vue?vue&type=style&index=0&id=d487045c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d487045c",
  null
  
)

export default component.exports